export enum ButtonType {
  primary = 'primary',
  success = 'success',
  secondary = 'secondary',
}
